var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulseIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 68",
    style: {
      enableBackground: "new 0 0 102 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.8;enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,55.4v4.1h-7.6v-4.1c0-20-16.2-36.3-36.3-36.3S17.9,35.4,17.9,55.4l0,0v4.1H4.1v-4.1 c0-25.9,21-46.9,46.9-46.9S97.9,29.5,97.9,55.4z M50.3,30.5c-13.8,0-24.9,11.2-24.9,24.9v4.1h13.8v-4.1l0,0 c0-7.9,6.4-14.3,14.3-14.3c5.5,0,10.2,3.1,12.6,7.6c1.1,2,1.7,4.3,1.7,6.7v4.1h7.6v-4.1C75.3,41.6,64.1,30.5,50.3,30.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseIconWhite);
export default __webpack_public_path__ + "static/media/pulse-icon-white.a473683afef9b0c37fc9c32ca15657b9.svg";
export { ForwardRef as ReactComponent };